/**
 * Display-only permission helpers. Never use for real access control —
 * the API enforces requirePermission. Refresh via AdminRoute /user/me;
 * clear on logout (clearStoredAdmin).
 */

export function readStoredAdmin() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function clearStoredAdmin() {
  try {
    localStorage.removeItem("user");
  } catch {
    /* ignore */
  }
}

export function effectivePermissions(user) {
  if (!user) return [];
  if (user.isSuperAdmin === true) return ["*"];
  if (Array.isArray(user.effectivePermissions)) return user.effectivePermissions;
  if (Array.isArray(user.adminPermissions)) return user.adminPermissions;
  return [];
}

export function hasPermission(user, key) {
  if (!user || !key) return false;
  if (user.isSuperAdmin === true) return true;
  const list = effectivePermissions(user);
  if (list.includes("*") || list.includes("admin.manage")) return true;
  return list.includes(key);
}

export function canManageAdmins(user) {
  return hasPermission(user, "admin.manage");
}

/** UI gating only — localStorage cache from last /user/me. */
export function meCan(key) {
  return hasPermission(readStoredAdmin(), key);
}
